import React from 'react'
import PropTypes from 'prop-types'

import { translate } from 'parking-react-common'

const ErrorPage = ({ errorType, t }) => ({
    render() {
        switch (errorType) {
            case 'notFound':
                return (
                    <div>
                        <h3>{ t('404 page not found') }</h3>
                        <p>{ t('We are sorry but the page you are looking for does not exist.') }</p>
                    </div>
                )
            default:
                return (
                    <div>
                        <h3>{ t('An unknown error has occured') }</h3>
                    </div>
                )
        }
    }
})

ErrorPage.propTypes = {
    errorType: PropTypes.oneOf(['notFound'])
}

export default translate()(ErrorPage)
